import * as types from "../mutation-types";
import configuracionAPI from "@/api/configuracion";

export const state = {
    configuraciones: [],
    loadingConfiguraciones: false,
    configuracion: null,
};

export const actions = {
    getConfiguraciones({ commit }, payload) {
        commit(types.REPLACE_LOADING_CONFIGURACIONES, { status: true });
        return new Promise((resolve, reject) => {
            configuracionAPI
                .get(payload)
                .then(response => {
                    const configuraciones = response.data.data;

                    commit(types.REPLACE_LOADING_CONFIGURACIONES, { status: false });
                    commit(types.REPLACE_CONFIGURACIONES, { configuraciones });

                    resolve(response);
                })
                .catch(error => {
                    commit(types.REPLACE_LOADING_CONFIGURACIONES, { status: false });
                    reject(error);
                });
        });
    },

    getConfiguracion({ commit }, payload) {
        return new Promise((resolve, reject) => {
            configuracionAPI
                .getById(payload)
                .then(response => {
                    const configuracion = response.data.data;

                    commit(types.REPLACE_CURRENT_CONFIGURACION, { configuracion });

                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    updateConfiguracion({ commit }, payload) {
        return new Promise((resolve, reject) => {
            configuracionAPI
                .put(payload)
                .then(response => {
                    this._vm.$notify.success({
                        title: "Info",
                        message: "La configuracion ha sido actualizado con éxito."
                    });
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    replaceCurrentConfiguracion({ commit }, payload) {
        commit(types.REPLACE_CURRENT_CONFIGURACION, payload);
    }
};

export const mutations = {
    [types.REPLACE_LOADING_CONFIGURACIONES](state, { status }) {
        state.loadingConfiguraciones = status;
    },
    [types.REPLACE_CONFIGURACIONES](state, { configuraciones }) {
        state.configuraciones = configuraciones;
    },
    [types.REPLACE_CURRENT_CONFIGURACION](state, { configuracion }) {
        state.configuracion = configuracion;
    }
};